import React, { Component } from "react";
import Image from '../global/Image';

export default class PagePartner extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="l-content l-content--fixed-width c-partner">
			    		
			    		<div className="l-grid l-grid--m-reverse">
			    			
			    			{block.src &&
				    			<>
					    			<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-5-12 l-grid__col--l-push-1-12">
					    				<div className="c-partner__image">			    				    
											<Image srcset={block.srcset} src={block.src}></Image>
										</div>
									</div>
									<div className="c-partner__space"></div>
								</>
							}
							<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-6-12">
								{block.heading &&
									<h3 className="c-paragraph c-paragraph--xxlarge c-paragraph--space" dangerouslySetInnerHTML={{__html:block.heading}}></h3>
								}
								<div className="scope-text scope-text--xlarge" dangerouslySetInnerHTML={{__html:block.text}}></div>
								{block.button_text && block.button_url &&
									<a href={block.button_url} target="_blank" className="c-partner__button" dangerouslySetInnerHTML={{__html:block.button_text}}></a>
								}
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
